import SvgIcon, { SvgIconProps } from '@mui/material/SvgIcon';
import { ReactComponent as Half } from '../../images/messenger.svg';

export const MessengerIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} component={Half} />
);

export default MessengerIcon;
